export type { GetCustomerTermsResponseDto as CustomerTerms } from '@helios/frontend-api-v2-client';

export const termsAndConditionsName = 'termsandconditions';
